import { classifyLegForRollup } from "./legPurposeHeuristic";
import type { FlightLeg } from "./types";

/** How we decide a leg is “personal” when the CSV / DB flag is missing. */
export type PersonalBasis = "log_only" | "log_or_route_time_share" | "notes_and_airports";

const STORAGE_KEY = "flights_personal_basis_v1";

export function loadPersonalBasis(): PersonalBasis {
  try {
    const v = localStorage.getItem(STORAGE_KEY);
    if (v === "log_only" || v === "log_or_route_time_share" || v === "notes_and_airports") {
      return v;
    }
  } catch {
    /* ignore */
  }
  return "notes_and_airports";
}

export function savePersonalBasis(basis: PersonalBasis): void {
  try {
    localStorage.setItem(STORAGE_KEY, basis);
  } catch {
    /* ignore */
  }
}

/** True if route notes indicate a timeshare leg (ForeFlight / worksheet convention). */
export function routeNotesIndicateTimeShare(routeNotes: string | null | undefined): boolean {
  return /\btime\s*share\b/i.test(routeNotes ?? "");
}

export function resolvePersonalLeg(leg: FlightLeg, basis: PersonalBasis): boolean {
  if (basis === "notes_and_airports") {
    return classifyLegForRollup(leg).personal;
  }
  if (leg.personalUse) return true;
  if (basis === "log_only") return false;
  return routeNotesIndicateTimeShare(leg.routeNotes);
}

export function personalResolverForBasis(
  basis: PersonalBasis
): (leg: FlightLeg) => boolean {
  return (leg) => resolvePersonalLeg(leg, basis);
}
